import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import WebsiteApiService from '../../ApiServices/WebsiteApiService/WebsiteApiService';
import AdunitApiService from '../../ApiServices/AnalyticsApiService/AdunitApiService';
import PublisherApiService from '../../ApiServices/PublisherApiService/PublisherApiService';
import { toast } from 'react-toastify';

const EditForm = ({ entry, onUpdate, onCancel }) => {
    const [formData, setFormData] = useState(entry);
    const [loading, setLoading] = useState(false);
    const [publishersData, setPublishers] = useState([]);
    const [webData, setWebsites] = useState([]);
    const [adunitsData, setAdunitsData] = useState([]);

    useEffect(() => {
        fetchPublishers();
        fetchAdunits();
    }, []);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (date) => {
        setFormData({ ...formData, date });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onUpdate(formData);
    };

    const fetchPublishers = async () => {
        try {
            const response = await PublisherApiService.get();
            setPublishers(response.data || []);
        } catch {
            toast.error("🚫 Failed to load publishers");
        }
    };

    const fetchAdunits = async () => {
        setLoading(true);
        try {
            const response = await AdunitApiService.getAll();
            setAdunitsData(response.data || []);
        } catch {
            toast.error('🚫 Failed to fetch adunits.');
        } finally {
            setLoading(false);
        }
    };

    const fetchWebsites = async (publisherId) => {
        if (!publisherId) {
            setWebsites([]);
            return;
        }
        try {
            const response = await WebsiteApiService.GetAllWebByUserId(publisherId);
            setWebsites(response.data || []);
        } catch {
            toast.error("🚫 Failed to load websites");
        }
    };

    const handlePublisherChange = (e) => {
        const publisherId = e.target.value;
        setFormData((prev) => ({ ...prev, publisher: publisherId, website: '' }));
        fetchWebsites(publisherId);
    };

    const readableLabel = (field) =>
        field
            .replace(/^adExchange/, '')
            .replace(/([A-Z])/g, ' $1')
            .replace(/\bCTR\b/, 'CTR (%)')
            .trim();

    return (
        <form onSubmit={handleSubmit} className="space-y-6 p-8 bg-white shadow-xl rounded-2xl border border-gray-200">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">📝 Edit Analytics Entry</h2>

            {/* Uncomment below if needed */}
            {/* 
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                    <label className="text-gray-600 font-medium mb-1 block">📅 Date</label>
                    <DatePicker
                        selected={formData.date}
                        onChange={handleDateChange}
                        className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:ring focus:ring-indigo-300"
                        required
                    />
                </div>
                <div>
                    <label className="text-gray-600 font-medium mb-1 block">🎯 Adunit</label>
                    <select
                        name="adunit"
                        value={formData.adunit}
                        onChange={handleInputChange}
                        className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:ring focus:ring-indigo-300"
                        required
                    >
                        <option value="">Select Adunit</option>
                        {adunitsData.map((adunit) => (
                            <option key={adunit.id} value={adunit.id}>{adunit.name}</option>
                        ))}
                    </select>
                </div>
            </div>
            */}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                {[
                    'adExchangeImpressions',
                    'adExchangeClicks',
                    'adExchangeCTR',
                    'adExchangeRevenue',
                    'adExchangePayout',
                    'adExchangeAvgECPM',
                    'adExchangeAdRequests',
                    'adExchangeMatchRate',
                    'adExchangeFillRate'
                ].map((field) => (
                    <div key={field}>
                        <label className="text-gray-600 font-medium mb-1 block">{readableLabel(field)}</label>
                        <input
                            name={field}
                            type="number"
                            value={formData[field]}
                            onChange={handleInputChange}
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:ring focus:ring-indigo-300"
                            required
                        />
                    </div>
                ))}
            </div>

            <div className="flex justify-end space-x-4 pt-4">
                <button
                    type="button"
                    onClick={onCancel}
                    className="px-6 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
                >
                    ❌ Cancel
                </button>
                <button
                    type="submit"
                    disabled={loading}
                    className="px-6 py-2 bg-gradient-to-r from-indigo-500 to-purple-600 text-white rounded-lg shadow-md hover:from-indigo-600 hover:to-purple-700 transition"
                >
                    {loading ? "⏳ Updating..." : "✅ Update"}
                </button>
            </div>
        </form>
    );
};

export default EditForm;
